import { round, isNaN as isNaN$1, isObject as isObject$1, isDate, isEmpty, get, isFunction } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import isArray from 'lodash-es/isArray';
import isObject from 'lodash-es/isObject';
import { serialize } from 'object-to-formdata';
import dayjs from 'dayjs';
import dayjsAdvFmt from 'dayjs/plugin/advancedFormat';
import { DateTime } from 'luxon';
import i18next, { t } from 'i18next';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import React, { createRef, useContext, useState, useLayoutEffect, useEffect, useDebugValue, createContext, useCallback, useRef } from 'react';
import { stringify, parse } from 'query-string';
import { useFirstMountState } from '@react-hookz/web';
import { useLocation, useNavigate } from 'react-router-dom';
import { string, ref, number, date } from 'yup';
import UAParser from 'my-ua-parser';

var countryCodes = [{
  value: 'AF',
  label: 'Afghanistan'
}, {
  value: 'AL',
  label: 'Albania'
}, {
  value: 'DZ',
  label: 'Algeria'
}, {
  value: 'AS',
  label: 'American Samoa'
}, {
  value: 'AD',
  label: 'Andorra'
}, {
  value: 'AO',
  label: 'Angola'
}, {
  value: 'AI',
  label: 'Anguilla'
}, {
  value: 'AQ',
  label: 'Antarctica'
}, {
  value: 'AG',
  label: 'Antigua and Barbuda'
}, {
  value: 'AR',
  label: 'Argentina'
}, {
  value: 'AM',
  label: 'Armenia'
}, {
  value: 'AW',
  label: 'Aruba'
}, {
  value: 'AU',
  label: 'Australia'
}, {
  value: 'AT',
  label: 'Austria'
}, {
  value: 'AZ',
  label: 'Azerbaijan'
}, {
  value: 'BS',
  label: 'Bahamas (the)'
}, {
  value: 'BH',
  label: 'Bahrain'
}, {
  value: 'BD',
  label: 'Bangladesh'
}, {
  value: 'BB',
  label: 'Barbados'
}, {
  value: 'BY',
  label: 'Belarus'
}, {
  value: 'BE',
  label: 'Belgium'
}, {
  value: 'BZ',
  label: 'Belize'
}, {
  value: 'BJ',
  label: 'Benin'
}, {
  value: 'BM',
  label: 'Bermuda'
}, {
  value: 'BT',
  label: 'Bhutan'
}, {
  value: 'BO',
  label: 'Bolivia (Plurinational State of)'
}, {
  value: 'BQ',
  label: 'Bonaire, Sint Eustatius and Saba'
}, {
  value: 'BA',
  label: 'Bosnia and Herzegovina'
}, {
  value: 'BW',
  label: 'Botswana'
}, {
  value: 'BV',
  label: 'Bouvet Island'
}, {
  value: 'BR',
  label: 'Brazil'
}, {
  value: 'IO',
  label: 'British Indian Ocean Territory (the)'
}, {
  value: 'BN',
  label: 'Brunei Darussalam'
}, {
  value: 'BG',
  label: 'Bulgaria'
}, {
  value: 'BF',
  label: 'Burkina Faso'
}, {
  value: 'BI',
  label: 'Burundi'
}, {
  value: 'CV',
  label: 'Cabo Verde'
}, {
  value: 'KH',
  label: 'Cambodia'
}, {
  value: 'CM',
  label: 'Cameroon'
}, {
  value: 'CA',
  label: 'Canada'
}, {
  value: 'KY',
  label: 'Cayman Islands (the)'
}, {
  value: 'CF',
  label: 'Central African Republic (the)'
}, {
  value: 'TD',
  label: 'Chad'
}, {
  value: 'CL',
  label: 'Chile'
}, {
  value: 'CN',
  label: 'China'
}, {
  value: 'CX',
  label: 'Christmas Island'
}, {
  value: 'CC',
  label: 'Cocos (Keeling) Islands (the)'
}, {
  value: 'CO',
  label: 'Colombia'
}, {
  value: 'KM',
  label: 'Comoros (the)'
}, {
  value: 'CD',
  label: 'Congo (the Democratic Republic of the)'
}, {
  value: 'CG',
  label: 'Congo (the)'
}, {
  value: 'CK',
  label: 'Cook Islands (the)'
}, {
  value: 'CR',
  label: 'Costa Rica'
}, {
  value: 'HR',
  label: 'Croatia'
}, {
  value: 'CU',
  label: 'Cuba'
}, {
  value: 'CW',
  label: 'Curaçao'
}, {
  value: 'CY',
  label: 'Cyprus'
}, {
  value: 'CZ',
  label: 'Czechia'
}, {
  value: 'CI',
  label: "Côte d'Ivoire"
}, {
  value: 'DK',
  label: 'Denmark'
}, {
  value: 'DJ',
  label: 'Djibouti'
}, {
  value: 'DM',
  label: 'Dominica'
}, {
  value: 'DO',
  label: 'Dominican Republic (the)'
}, {
  value: 'EC',
  label: 'Ecuador'
}, {
  value: 'EG',
  label: 'Egypt'
}, {
  value: 'SV',
  label: 'El Salvador'
}, {
  value: 'GQ',
  label: 'Equatorial Guinea'
}, {
  value: 'ER',
  label: 'Eritrea'
}, {
  value: 'EE',
  label: 'Estonia'
}, {
  value: 'SZ',
  label: 'Eswatini'
}, {
  value: 'ET',
  label: 'Ethiopia'
}, {
  value: 'FK',
  label: 'Falkland Islands (the) [Malvinas]'
}, {
  value: 'FO',
  label: 'Faroe Islands (the)'
}, {
  value: 'FJ',
  label: 'Fiji'
}, {
  value: 'FI',
  label: 'Finland'
}, {
  value: 'FR',
  label: 'France'
}, {
  value: 'GF',
  label: 'French Guiana'
}, {
  value: 'PF',
  label: 'French Polynesia'
}, {
  value: 'TF',
  label: 'French Southern Territories (the)'
}, {
  value: 'GA',
  label: 'Gabon'
}, {
  value: 'GM',
  label: 'Gambia (the)'
}, {
  value: 'GE',
  label: 'Georgia'
}, {
  value: 'DE',
  label: 'Germany'
}, {
  value: 'GH',
  label: 'Ghana'
}, {
  value: 'GI',
  label: 'Gibraltar'
}, {
  value: 'GR',
  label: 'Greece'
}, {
  value: 'GL',
  label: 'Greenland'
}, {
  value: 'GD',
  label: 'Grenada'
}, {
  value: 'GP',
  label: 'Guadeloupe'
}, {
  value: 'GU',
  label: 'Guam'
}, {
  value: 'GT',
  label: 'Guatemala'
}, {
  value: 'GG',
  label: 'Guernsey'
}, {
  value: 'GN',
  label: 'Guinea'
}, {
  value: 'GW',
  label: 'Guinea-Bissau'
}, {
  value: 'GY',
  label: 'Guyana'
}, {
  value: 'HT',
  label: 'Haiti'
}, {
  value: 'HM',
  label: 'Heard Island and McDonald Islands'
}, {
  value: 'VA',
  label: 'Holy See (the)'
}, {
  value: 'HN',
  label: 'Honduras'
}, {
  value: 'HK',
  label: 'Hong Kong'
}, {
  value: 'HU',
  label: 'Hungary'
}, {
  value: 'IS',
  label: 'Iceland'
}, {
  value: 'IN',
  label: 'India'
}, {
  value: 'ID',
  label: 'Indonesia'
}, {
  value: 'IR',
  label: 'Iran (Islamic Republic of)'
}, {
  value: 'IQ',
  label: 'Iraq'
}, {
  value: 'IE',
  label: 'Ireland'
}, {
  value: 'IM',
  label: 'Isle of Man'
}, {
  value: 'IL',
  label: 'Israel'
}, {
  value: 'IT',
  label: 'Italy'
}, {
  value: 'JM',
  label: 'Jamaica'
}, {
  value: 'JP',
  label: 'Japan'
}, {
  value: 'JE',
  label: 'Jersey'
}, {
  value: 'JO',
  label: 'Jordan'
}, {
  value: 'KZ',
  label: 'Kazakhstan'
}, {
  value: 'KE',
  label: 'Kenya'
}, {
  value: 'KI',
  label: 'Kiribati'
}, {
  value: 'KP',
  label: "Korea (the Democratic People's Republic of)"
}, {
  value: 'KR',
  label: 'Korea (the Republic of)'
}, {
  value: 'KW',
  label: 'Kuwait'
}, {
  value: 'KG',
  label: 'Kyrgyzstan'
}, {
  value: 'LA',
  label: "Lao People's Democratic Republic (the)"
}, {
  value: 'LV',
  label: 'Latvia'
}, {
  value: 'LB',
  label: 'Lebanon'
}, {
  value: 'LS',
  label: 'Lesotho'
}, {
  value: 'LR',
  label: 'Liberia'
}, {
  value: 'LY',
  label: 'Libya'
}, {
  value: 'LI',
  label: 'Liechtenstein'
}, {
  value: 'LT',
  label: 'Lithuania'
}, {
  value: 'LU',
  label: 'Luxembourg'
}, {
  value: 'MO',
  label: 'Macao'
}, {
  value: 'MG',
  label: 'Madagascar'
}, {
  value: 'MW',
  label: 'Malawi'
}, {
  value: 'MY',
  label: 'Malaysia'
}, {
  value: 'MV',
  label: 'Maldives'
}, {
  value: 'ML',
  label: 'Mali'
}, {
  value: 'MT',
  label: 'Malta'
}, {
  value: 'MH',
  label: 'Marshall Islands (the)'
}, {
  value: 'MQ',
  label: 'Martinique'
}, {
  value: 'MR',
  label: 'Mauritania'
}, {
  value: 'MU',
  label: 'Mauritius'
}, {
  value: 'YT',
  label: 'Mayotte'
}, {
  value: 'MX',
  label: 'Mexico'
}, {
  value: 'FM',
  label: 'Micronesia (Federated States of)'
}, {
  value: 'MD',
  label: 'Moldova (the Republic of)'
}, {
  value: 'MC',
  label: 'Monaco'
}, {
  value: 'MN',
  label: 'Mongolia'
}, {
  value: 'ME',
  label: 'Montenegro'
}, {
  value: 'MS',
  label: 'Montserrat'
}, {
  value: 'MA',
  label: 'Morocco'
}, {
  value: 'MZ',
  label: 'Mozambique'
}, {
  value: 'MM',
  label: 'Myanmar'
}, {
  value: 'NA',
  label: 'Namibia'
}, {
  value: 'NR',
  label: 'Nauru'
}, {
  value: 'NP',
  label: 'Nepal'
}, {
  value: 'NL',
  label: 'Netherlands (the)'
}, {
  value: 'NC',
  label: 'New Caledonia'
}, {
  value: 'NZ',
  label: 'New Zealand'
}, {
  value: 'NI',
  label: 'Nicaragua'
}, {
  value: 'NE',
  label: 'Niger (the)'
}, {
  value: 'NG',
  label: 'Nigeria'
}, {
  value: 'NU',
  label: 'Niue'
}, {
  value: 'NF',
  label: 'Norfolk Island'
}, {
  value: 'MP',
  label: 'Northern Mariana Islands (the)'
}, {
  value: 'NO',
  label: 'Norway'
}, {
  value: 'OM',
  label: 'Oman'
}, {
  value: 'PK',
  label: 'Pakistan'
}, {
  value: 'PW',
  label: 'Palau'
}, {
  value: 'PS',
  label: 'Palestine, State of'
}, {
  value: 'PA',
  label: 'Panama'
}, {
  value: 'PG',
  label: 'Papua New Guinea'
}, {
  value: 'PY',
  label: 'Paraguay'
}, {
  value: 'PE',
  label: 'Peru'
}, {
  value: 'PH',
  label: 'Philippines (the)'
}, {
  value: 'PN',
  label: 'Pitcairn'
}, {
  value: 'PL',
  label: 'Poland'
}, {
  value: 'PT',
  label: 'Portugal'
}, {
  value: 'PR',
  label: 'Puerto Rico'
}, {
  value: 'QA',
  label: 'Qatar'
}, {
  value: 'MK',
  label: 'Republic of North Macedonia'
}, {
  value: 'RO',
  label: 'Romania'
}, {
  value: 'RU',
  label: 'Russian Federation (the)'
}, {
  value: 'RW',
  label: 'Rwanda'
}, {
  value: 'RE',
  label: 'Réunion'
}, {
  value: 'BL',
  label: 'Saint Barthélemy'
}, {
  value: 'SH',
  label: 'Saint Helena, Ascension and Tristan da Cunha'
}, {
  value: 'KN',
  label: 'Saint Kitts and Nevis'
}, {
  value: 'LC',
  label: 'Saint Lucia'
}, {
  value: 'MF',
  label: 'Saint Martin (French part)'
}, {
  value: 'PM',
  label: 'Saint Pierre and Miquelon'
}, {
  value: 'VC',
  label: 'Saint Vincent and the Grenadines'
}, {
  value: 'WS',
  label: 'Samoa'
}, {
  value: 'SM',
  label: 'San Marino'
}, {
  value: 'ST',
  label: 'Sao Tome and Principe'
}, {
  value: 'SA',
  label: 'Saudi Arabia'
}, {
  value: 'SN',
  label: 'Senegal'
}, {
  value: 'RS',
  label: 'Serbia'
}, {
  value: 'SC',
  label: 'Seychelles'
}, {
  value: 'SL',
  label: 'Sierra Leone'
}, {
  value: 'SG',
  label: 'Singapore'
}, {
  value: 'SX',
  label: 'Sint Maarten (Dutch part)'
}, {
  value: 'SK',
  label: 'Slovakia'
}, {
  value: 'SI',
  label: 'Slovenia'
}, {
  value: 'SB',
  label: 'Solomon Islands'
}, {
  value: 'SO',
  label: 'Somalia'
}, {
  value: 'ZA',
  label: 'South Africa'
}, {
  value: 'GS',
  label: 'South Georgia and the South Sandwich Islands'
}, {
  value: 'SS',
  label: 'South Sudan'
}, {
  value: 'ES',
  label: 'Spain'
}, {
  value: 'LK',
  label: 'Sri Lanka'
}, {
  value: 'SD',
  label: 'Sudan (the)'
}, {
  value: 'SR',
  label: 'Suriname'
}, {
  value: 'SJ',
  label: 'Svalbard and Jan Mayen'
}, {
  value: 'SE',
  label: 'Sweden'
}, {
  value: 'CH',
  label: 'Switzerland'
}, {
  value: 'SY',
  label: 'Syrian Arab Republic'
}, {
  value: 'TW',
  label: 'Taiwan'
}, {
  value: 'TJ',
  label: 'Tajikistan'
}, {
  value: 'TZ',
  label: 'Tanzania, United Republic of'
}, {
  value: 'TH',
  label: 'Thailand'
}, {
  value: 'TL',
  label: 'Timor-Leste'
}, {
  value: 'TG',
  label: 'Togo'
}, {
  value: 'TK',
  label: 'Tokelau'
}, {
  value: 'TO',
  label: 'Tonga'
}, {
  value: 'TT',
  label: 'Trinidad and Tobago'
}, {
  value: 'TN',
  label: 'Tunisia'
}, {
  value: 'TR',
  label: 'Turkey'
}, {
  value: 'TM',
  label: 'Turkmenistan'
}, {
  value: 'TC',
  label: 'Turks and Caicos Islands (the)'
}, {
  value: 'TV',
  label: 'Tuvalu'
}, {
  value: 'UG',
  label: 'Uganda'
}, {
  value: 'UA',
  label: 'Ukraine'
}, {
  value: 'AE',
  label: 'United Arab Emirates (the)'
}, {
  value: 'GB',
  label: 'United Kingdom of Great Britain and Northern Ireland (the)'
}, {
  value: 'UM',
  label: 'United States Minor Outlying Islands (the)'
}, {
  value: 'US',
  label: 'United States of America (the)'
}, {
  value: 'UY',
  label: 'Uruguay'
}, {
  value: 'UZ',
  label: 'Uzbekistan'
}, {
  value: 'VU',
  label: 'Vanuatu'
}, {
  value: 'VE',
  label: 'Venezuela (Bolivarian Republic of)'
}, {
  value: 'VN',
  label: 'Viet Nam'
}, {
  value: 'VG',
  label: 'Virgin Islands (British)'
}, {
  value: 'VI',
  label: 'Virgin Islands (U.S.)'
}, {
  value: 'WF',
  label: 'Wallis and Futuna'
}, {
  value: 'EH',
  label: 'Western Sahara'
}, {
  value: 'YE',
  label: 'Yemen'
}, {
  value: 'ZM',
  label: 'Zambia'
}, {
  value: 'ZW',
  label: 'Zimbabwe'
}, {
  value: 'AX',
  label: 'Åland Islands'
}];

var EMerchantPlan;
(function (EMerchantPlan) {
  EMerchantPlan[EMerchantPlan["Free"] = 1] = "Free";
  EMerchantPlan[EMerchantPlan["Premium"] = 2] = "Premium";
  EMerchantPlan[EMerchantPlan["Cardlink"] = 3] = "Cardlink";
  EMerchantPlan[EMerchantPlan["Legacy"] = 4] = "Legacy";
})(EMerchantPlan || (EMerchantPlan = {}));
var EDateFilterCompareTo;
(function (EDateFilterCompareTo) {
  EDateFilterCompareTo["PreviousPeriod"] = "previous_period";
  EDateFilterCompareTo["PreviousMonth"] = "previous_month";
  EDateFilterCompareTo["NoComparison"] = "no_comparison";
})(EDateFilterCompareTo || (EDateFilterCompareTo = {}));
var ECampaignStatus;
(function (ECampaignStatus) {
  ECampaignStatus[ECampaignStatus["Drafted"] = 1] = "Drafted";
  ECampaignStatus[ECampaignStatus["Scheduled"] = 2] = "Scheduled";
  ECampaignStatus[ECampaignStatus["Active"] = 3] = "Active";
  ECampaignStatus[ECampaignStatus["Paused"] = 4] = "Paused";
  ECampaignStatus[ECampaignStatus["Expired"] = 5] = "Expired";
  ECampaignStatus[ECampaignStatus["Canceled"] = 6] = "Canceled";
})(ECampaignStatus || (ECampaignStatus = {}));
var ECampaignApprovalStatus;
(function (ECampaignApprovalStatus) {
  ECampaignApprovalStatus[ECampaignApprovalStatus["Pending"] = 1] = "Pending";
  ECampaignApprovalStatus[ECampaignApprovalStatus["Approved"] = 2] = "Approved";
  ECampaignApprovalStatus[ECampaignApprovalStatus["Rejected"] = 3] = "Rejected";
})(ECampaignApprovalStatus || (ECampaignApprovalStatus = {}));
var EMetricChange;
(function (EMetricChange) {
  EMetricChange["INCREASE"] = "Increase";
  EMetricChange["DECREASE"] = "Decrease";
  EMetricChange["NO_CHANGE"] = "No Change";
})(EMetricChange || (EMetricChange = {}));

var SI_SYMBOL = ['', 'k', 'M', 'B', 'T'];
/**
 * Abbr. number ie: 1,000 => 1k
 *
 * @param value - number to abbr
 * @param fallback - returned if NaN
 */
function numberSuffix(value, fallback) {
  var tier = Math.log10(value) / 3 | 0;
  var maxTier = SI_SYMBOL.length - 1;
  if (tier === 0) {
    var _results = round(value, 2);
    if (isNaN$1(_results) && fallback) {
      return "" + (fallback != null ? fallback : value);
    }
    return "" + _results;
  }
  if (tier > maxTier) {
    tier = maxTier;
  }
  var suffix = SI_SYMBOL[tier];
  var scale = Math.pow(10, tier * 3);
  var scaled = value / scale;
  var results = round(scaled, 1) + suffix;
  if (isNaN$1(results)) {
    return "" + (fallback != null ? fallback : value);
  }
  return results;
}

var formatNumberCommas = function formatNumberCommas(number, hideDecimal) {
  number = Number(number);
  if (hideDecimal) {
    return number.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
var isDecimalNumber = function isDecimalNumber(number) {
  return number % 1 !== 0;
};
var removeLeadingDecimalZeros = function removeLeadingDecimalZeros(number) {
  return number.toString().replace(/[.]00$/, '').replace(/[.]0$/, '');
};
var formatNumberThousands = function formatNumberThousands(number, hideDecimal) {
  if (number >= 1000) {
    return (number / 1000).toFixed(1) + "K";
  }
  return formatNumberCommas(number, hideDecimal);
};
var formatNumberPhone = function formatNumberPhone(numberStr) {
  var digitsOnly = numberStr.replace(/\D/g, '');
  // 020 100 000 0000
  if (digitsOnly.startsWith('020')) {
    return "+20 " + digitsOnly.slice(3, 6) + " " + digitsOnly.slice(6, 9) + " " + digitsOnly.slice(9);
  }
  // 20 100 000 0000
  if (digitsOnly.startsWith('20')) {
    return "+20 " + digitsOnly.slice(2, 5) + " " + digitsOnly.slice(5, 8) + " " + digitsOnly.slice(8);
  }
  // 0 100 000 0000
  if (digitsOnly.startsWith('01')) {
    return "+20 " + digitsOnly.slice(1, 4) + " " + digitsOnly.slice(4, 7) + " " + digitsOnly.slice(7);
  }
  return digitsOnly;
};
var abbreviateNumber = function abbreviateNumber(num, decPlaces) {
  if (decPlaces === void 0) {
    decPlaces = 1;
  }
  var abbrev = ['K', 'M', 'B', 'T'];
  var decPlacesFactor = Math.pow(10, decPlaces);
  for (var i = abbrev.length - 1; i >= 0; i--) {
    var size = Math.pow(10, (i + 1) * 3);
    if (size <= num) {
      num = Math.round(num * decPlacesFactor / size) / decPlacesFactor;
      if (num === 1000 && i < abbrev.length - 1) {
        num = 1;
        i++;
      }
      return num + abbrev[i];
    }
  }
  return num.toString();
};
var numberWithSpaces = function numberWithSpaces(value, pattern) {
  var i = 0;
  var phone = value.toString();
  return pattern.replace(/#/g, function (_) {
    return phone[i++];
  });
};

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return r;
  };
  var t,
    r = {},
    e = Object.prototype,
    n = e.hasOwnProperty,
    o = "function" == typeof Symbol ? Symbol : {},
    i = o.iterator || "@@iterator",
    a = o.asyncIterator || "@@asyncIterator",
    u = o.toStringTag || "@@toStringTag";
  function c(t, r, e, n) {
    return Object.defineProperty(t, r, {
      value: e,
      enumerable: !n,
      configurable: !n,
      writable: !n
    });
  }
  try {
    c({}, "");
  } catch (t) {
    c = function (t, r, e) {
      return t[r] = e;
    };
  }
  function h(r, e, n, o) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype);
    return c(a, "_invoke", function (r, e, n) {
      var o = 1;
      return function (i, a) {
        if (3 === o) throw Error("Generator is already running");
        if (4 === o) {
          if ("throw" === i) throw a;
          return {
            value: t,
            done: !0
          };
        }
        for (n.method = i, n.arg = a;;) {
          var u = n.delegate;
          if (u) {
            var c = d(u, n);
            if (c) {
              if (c === f) continue;
              return c;
            }
          }
          if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
            if (1 === o) throw o = 4, n.arg;
            n.dispatchException(n.arg);
          } else "return" === n.method && n.abrupt("return", n.arg);
          o = 3;
          var h = s(r, e, n);
          if ("normal" === h.type) {
            if (o = n.done ? 4 : 2, h.arg === f) continue;
            return {
              value: h.arg,
              done: n.done
            };
          }
          "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg);
        }
      };
    }(r, n, new Context(o || [])), !0), a;
  }
  function s(t, r, e) {
    try {
      return {
        type: "normal",
        arg: t.call(r, e)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  r.wrap = h;
  var f = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var l = {};
  c(l, i, function () {
    return this;
  });
  var p = Object.getPrototypeOf,
    y = p && p(p(x([])));
  y && y !== e && n.call(y, i) && (l = y);
  var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l);
  function g(t) {
    ["next", "throw", "return"].forEach(function (r) {
      c(t, r, function (t) {
        return this._invoke(r, t);
      });
    });
  }
  function AsyncIterator(t, r) {
    function e(o, i, a, u) {
      var c = s(t[o], t, i);
      if ("throw" !== c.type) {
        var h = c.arg,
          f = h.value;
        return f && "object" == typeof f && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) {
          e("next", t, a, u);
        }, function (t) {
          e("throw", t, a, u);
        }) : r.resolve(f).then(function (t) {
          h.value = t, a(h);
        }, function (t) {
          return e("throw", t, a, u);
        });
      }
      u(c.arg);
    }
    var o;
    c(this, "_invoke", function (t, n) {
      function i() {
        return new r(function (r, o) {
          e(t, n, r, o);
        });
      }
      return o = o ? o.then(i, i) : i();
    }, !0);
  }
  function d(r, e) {
    var n = e.method,
      o = r.i[n];
    if (o === t) return e.delegate = null, "throw" === n && r.i.return && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f;
    var i = s(o, r.i, e.arg);
    if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f;
    var a = i.arg;
    return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f);
  }
  function w(t) {
    this.tryEntries.push(t);
  }
  function m(r) {
    var e = r[4] || {};
    e.type = "normal", e.arg = t, r[4] = e;
  }
  function Context(t) {
    this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0);
  }
  function x(r) {
    if (null != r) {
      var e = r[i];
      if (e) return e.call(r);
      if ("function" == typeof r.next) return r;
      if (!isNaN(r.length)) {
        var o = -1,
          a = function e() {
            for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e;
            return e.value = t, e.done = !0, e;
          };
        return a.next = a;
      }
    }
    throw new TypeError(typeof r + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) {
    var r = "function" == typeof t && t.constructor;
    return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name));
  }, r.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t;
  }, r.awrap = function (t) {
    return {
      __await: t
    };
  }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () {
    return this;
  }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(h(t, e, n, o), i);
    return r.isGeneratorFunction(e) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, g(v), c(v, u, "Generator"), c(v, i, function () {
    return this;
  }), c(v, "toString", function () {
    return "[object Generator]";
  }), r.keys = function (t) {
    var r = Object(t),
      e = [];
    for (var n in r) e.unshift(n);
    return function t() {
      for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t;
      return t.done = !0, t;
    };
  }, r.values = x, Context.prototype = {
    constructor: Context,
    reset: function (r) {
      if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0][4];
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (r) {
      if (this.done) throw r;
      var e = this;
      function n(t) {
        a.type = "throw", a.arg = r, e.next = t;
      }
      for (var o = e.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i[4],
          u = this.prev,
          c = i[1],
          h = i[2];
        if (-1 === i[0]) return n("end"), !1;
        if (!c && !h) throw Error("try statement without catch or finally");
        if (null != i[0] && i[0] <= u) {
          if (u < c) return this.method = "next", this.arg = t, n(c), !0;
          if (u < h) return n(h), !1;
        }
      }
    },
    abrupt: function (t, r) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var n = this.tryEntries[e];
        if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) {
          var o = n;
          break;
        }
      }
      o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null);
      var i = o ? o[4] : {};
      return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i);
    },
    complete: function (t, r) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f;
    },
    finish: function (t) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var e = this.tryEntries[r];
        if (e[2] === t) return this.complete(e[4], e[3]), m(e), f;
      }
    },
    catch: function (t) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var e = this.tryEntries[r];
        if (e[0] === t) {
          var n = e[4];
          if ("throw" === n.type) {
            var o = n.arg;
            m(e);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (r, e, n) {
      return this.delegate = {
        i: x(r),
        r: e,
        n: n
      }, "next" === this.method && (this.arg = t), f;
    }
  }, r;
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function (t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}

var useI18nTranslation = useTranslation;
var useDocumentDirection = function useDocumentDirection() {
  var _useTranslation = useTranslation(),
    i18n = _useTranslation.i18n;
  return (i18n.dir == null ? void 0 : i18n.dir()) || 'ltr';
};

function useFormatNumber() {
  var _useTranslation = useI18nTranslation(),
    i18n = _useTranslation.i18n;
  var locale = i18n.language || i18n.resolvedLanguage;
  var formatPercentage = function formatPercentage(value, fractionDigits, options) {
    if (fractionDigits === void 0) {
      fractionDigits = 2;
    }
    return new Intl.NumberFormat(locale, _extends({
      style: 'percent',
      maximumFractionDigits: fractionDigits != null ? fractionDigits : 2
    }, options)).format(value / 100 || 0);
  };
  var formatNumber = function formatNumber(value, fractionDigits, options) {
    if (fractionDigits === void 0) {
      fractionDigits = 2;
    }
    return new Intl.NumberFormat(locale, _extends({
      maximumFractionDigits: fractionDigits != null ? fractionDigits : 2
    }, options)).format(value || 0);
  };
  var formatCurrency = function formatCurrency(value, currencyCode, fractionDigits, options) {
    if (fractionDigits === void 0) {
      fractionDigits = 2;
    }
    try {
      return new Intl.NumberFormat(locale, _extends({
        style: 'currency',
        currency: currencyCode,
        maximumFractionDigits: fractionDigits != null ? fractionDigits : 2
      }, options)).format(value || 0);
    } catch (_unused) {
      return new Intl.NumberFormat(locale, _extends({
        style: 'currency',
        currency: 'EGP',
        maximumFractionDigits: fractionDigits != null ? fractionDigits : 2
      }, options)).format(value || 0);
    }
  };
  return {
    formatPercentage: formatPercentage,
    formatNumber: formatNumber,
    formatCurrency: formatCurrency
  };
}

/**
 * remove null|undefined values from array|objects
 */
function sanitize(o) {
  if (isArray(o)) {
    return o.reduce(function (a, v) {
      if (v !== undefined) {
        a.push(v);
      }
      return a;
    }, []);
  }
  if (isObject(o)) {
    return Object.entries(o).reduce(function (a, _ref) {
      var k = _ref[0],
        v = _ref[1];
      if (v !== undefined) {
        a[k] = v;
      }
      return a;
    }, {});
  }
  return o;
}

function parseJson(o, fallback) {
  try {
    return JSON.parse(o);
  } catch (_unused) {
    return fallback || o;
  }
}

var toFormData = function toFormData(object, options) {
  var formData = serialize(object, _extends({}, baseOptions, options));
  return formData;
};
var baseOptions = {
  /**
   * include array indices in FormData keys
   * defaults to false
   */
  indices: true,
  /**
   * treat null values like undefined values and ignore them
   * defaults to false
   */
  nullsAsUndefineds: true,
  /**
   * convert true or false to 1 or 0 respectively
   * defaults to false
   */
  booleansAsIntegers: true,
  /**
   * store arrays even if they're empty
   * defaults to false
   */
  allowEmptyArrays: false,
  /**
   * don't include array notation in FormData keys for any attributes except Files in arrays
   * defaults to false
   */
  noAttributesWithArrayNotation: false,
  /**
   * don't include array notation in FormData keys for Files in arrays
   * defaults to false
   */
  noFilesWithArrayNotation: false,
  /**
   * use dots instead of brackets for object notation in FormData keys
   * defaults to false
   */
  dotsForObjectNotation: false
};

var apiPath = {
  // @ts-expect-error - needs to be fixed
  host: import.meta.env.REACT_APP_API_HOST,
  // @ts-expect-error - needs to be fixed
  base: import.meta.env.REACT_APP_API_BASE
};
var __middlewares__ = [];
var ApiRequestError = /*#__PURE__*/function (_Error) {
  function ApiRequestError() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this = _Error.call.apply(_Error, [this].concat(args)) || this;
    _this.response = null;
    _this.stack = undefined;
    _this.meta = {};
    return _this;
  }
  _inheritsLoose(ApiRequestError, _Error);
  return ApiRequestError;
}(/*#__PURE__*/_wrapNativeSuper(Error));
var ApiRequest = /*#__PURE__*/function () {
  /**
   * @param path - api path
   * @param [urlQueryObject] - url query string object
   */
  function ApiRequest(path, urlQueryObject, options) {
    if (urlQueryObject === void 0) {
      urlQueryObject = {};
    }
    this._path = void 0;
    this._query = {};
    this._options = {};
    this._middlewares = [];
    this._headers = {
      Accept: 'application/json'
    };
    this._body = '';
    this._path = path;
    if (isObject$1(urlQueryObject)) {
      this._query = urlQueryObject;
    }
    if (options && isObject$1(options)) {
      this._options = options;
    }
  }
  ApiRequest.setURL = function setURL(host, base) {
    apiPath.host = host;
    apiPath.base = base;
  };
  ApiRequest.getURL = function getURL() {
    return apiPath.host + "/" + apiPath.base;
  };
  ApiRequest.use = function use() {
    for (var _len2 = arguments.length, middlewares = new Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
      middlewares[_key3] = arguments[_key3];
    }
    middlewares.forEach(function (m) {
      __middlewares__.push(m);
    });
  };
  var _proto = ApiRequest.prototype;
  _proto.use = function use() {
    var _this2 = this;
    for (var _len3 = arguments.length, middlewares = new Array(_len3), _key4 = 0; _key4 < _len3; _key4++) {
      middlewares[_key4] = arguments[_key4];
    }
    middlewares.forEach(function (m) {
      _this2._middlewares.push(m);
    });
  };
  _proto.__fetch = /*#__PURE__*/function () {
    var _fetch = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(opt, cfg) {
      var _this3 = this;
      var meta, path, initConfig;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (cfg === void 0) {
              cfg = {};
            }
            meta = _extends({}, opt, {
              config: cfg,
              url: this.url.toString(),
              path: this._path
            });
            _context3.next = 4;
            return this.__runMiddlewares(null, null, meta);
          case 4:
            path = this.url.toString();
            initConfig = _extends({}, this._options, opt, {
              headers: Object.assign(this._headers, opt._headers)
            }); // console.warn('===[API]===', path, '\n', initConfig);
            return _context3.abrupt("return", fetch(path, initConfig).then(/*#__PURE__*/function () {
              var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(resp) {
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      if (resp.ok) {
                        _context.next = 2;
                        break;
                      }
                      return _context.abrupt("return", Promise.reject({
                        response: resp
                      }));
                    case 2:
                      _context.next = 4;
                      return _this3.__runMiddlewares(null, resp, meta);
                    case 4:
                      return _context.abrupt("return", Promise.resolve(resp));
                    case 5:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x3) {
                return _ref.apply(this, arguments);
              };
            }())["catch"](/*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(err) {
                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return _this3.__runMiddlewares(err, null, meta);
                    case 2:
                      return _context2.abrupt("return", Promise.reject(err));
                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee2);
              }));
              return function (_x4) {
                return _ref2.apply(this, arguments);
              };
            }()));
          case 7:
          case "end":
            return _context3.stop();
        }
      }, _callee3, this);
    }));
    function __fetch(_x, _x2) {
      return _fetch.apply(this, arguments);
    }
    return __fetch;
  }();
  _proto.__runMiddlewares = /*#__PURE__*/function () {
    var _runMiddlewares = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(error, response, meta) {
      var i, _i;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            i = 0;
          case 1:
            if (!(i < __middlewares__.length)) {
              _context4.next = 7;
              break;
            }
            _context4.next = 4;
            return __middlewares__[i](error, this, response, meta);
          case 4:
            i++;
            _context4.next = 1;
            break;
          case 7:
            _i = 0;
          case 8:
            if (!(_i < this._middlewares.length)) {
              _context4.next = 14;
              break;
            }
            _context4.next = 11;
            return this._middlewares[_i](error, this, response, meta);
          case 11:
            _i++;
            _context4.next = 8;
            break;
          case 14:
          case "end":
            return _context4.stop();
        }
      }, _callee4, this);
    }));
    function __runMiddlewares(_x5, _x6, _x7) {
      return _runMiddlewares.apply(this, arguments);
    }
    return __runMiddlewares;
  }();
  _proto.__preFetch = /*#__PURE__*/function () {
    var _preFetch = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(method, callback, meta) {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (meta === void 0) {
              meta = {};
            }
            _context5.next = 3;
            return this.__runMiddlewares(null, null, _extends({}, meta, {
              method: method,
              callback: callback
            }));
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5, this);
    }));
    function __preFetch(_x8, _x9, _x0) {
      return _preFetch.apply(this, arguments);
    }
    return __preFetch;
  }();
  _proto.__postFetch = /*#__PURE__*/function () {
    var _postFetch = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(method, response, meta) {
      var payload, err;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (!response.ok) {
              _context6.next = 7;
              break;
            }
            _context6.next = 3;
            return response.json();
          case 3:
            payload = _context6.sent;
            return _context6.abrupt("return", Promise.resolve(payload));
          case 7:
            err = new ApiRequestError("Error: [" + method + "] " + response.status + " [" + response.statusText + "]");
            err.meta = meta;
            err.response = response;
            return _context6.abrupt("return", Promise.reject(err));
          case 11:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    function __postFetch(_x1, _x10, _x11) {
      return _postFetch.apply(this, arguments);
    }
    return __postFetch;
  }();
  _proto.setQuery = function setQuery(urlQueryObject) {
    if (isObject$1(urlQueryObject)) {
      this._query = urlQueryObject;
    }
    return this;
  };
  _proto.setBody = function setBody(payload) {
    this._body = payload;
    return this;
  };
  _proto.addQuery = function addQuery(key, value) {
    var _this4 = this;
    if (Array.isArray(value)) {
      value.forEach(function (v, idx) {
        var _key = key + "[" + idx + "]";
        _this4._query[_key] = v;
      });
    } else {
      this._query[key] = value;
    }
    return this;
  };
  _proto.addHeader = function addHeader(key, value) {
    this._headers[key] = "" + value;
    return this;
  };
  _proto.addOption = function addOption(key, value) {
    this._options[key] = value;
    return this;
  };
  _proto.GET = /*#__PURE__*/function () {
    var _GET = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(options) {
      var resp;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return this.__fetch({
              method: 'GET'
            }, options);
          case 2:
            resp = _context7.sent;
            return _context7.abrupt("return", this.__postFetch('GET', resp, {
              options: options
            }));
          case 4:
          case "end":
            return _context7.stop();
        }
      }, _callee7, this);
    }));
    function GET(_x12) {
      return _GET.apply(this, arguments);
    }
    return GET;
  }();
  _proto.DELETE = /*#__PURE__*/function () {
    var _DELETE = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(body, options) {
      var resp;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return this.__fetch({
              method: 'DELETE',
              body: body || this._body
            });
          case 2:
            resp = _context8.sent;
            return _context8.abrupt("return", this.__postFetch('DELETE', resp, {
              options: options
            }));
          case 4:
          case "end":
            return _context8.stop();
        }
      }, _callee8, this);
    }));
    function DELETE(_x13, _x14) {
      return _DELETE.apply(this, arguments);
    }
    return DELETE;
  }();
  _proto.POST = /*#__PURE__*/function () {
    var _POST = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(body, options) {
      var resp;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            if (options === void 0) {
              options = {};
            }
            _context9.next = 3;
            return this.__fetch({
              method: 'POST',
              body: body || this._body
            }, options);
          case 3:
            resp = _context9.sent;
            return _context9.abrupt("return", this.__postFetch('POST', resp, {
              options: options
            }));
          case 5:
          case "end":
            return _context9.stop();
        }
      }, _callee9, this);
    }));
    function POST(_x15, _x16) {
      return _POST.apply(this, arguments);
    }
    return POST;
  }();
  _proto.PUT = /*#__PURE__*/function () {
    var _PUT = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee0(body, options) {
      var resp;
      return _regeneratorRuntime().wrap(function _callee0$(_context0) {
        while (1) switch (_context0.prev = _context0.next) {
          case 0:
            if (options === void 0) {
              options = {};
            }
            _context0.next = 3;
            return this.__fetch({
              method: 'PUT',
              body: body || this._body
            }, options);
          case 3:
            resp = _context0.sent;
            return _context0.abrupt("return", this.__postFetch('PUT', resp, {
              options: options
            }));
          case 5:
          case "end":
            return _context0.stop();
        }
      }, _callee0, this);
    }));
    function PUT(_x17, _x18) {
      return _PUT.apply(this, arguments);
    }
    return PUT;
  }();
  _proto.PATCH = /*#__PURE__*/function () {
    var _PATCH = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee1(body, options) {
      var resp;
      return _regeneratorRuntime().wrap(function _callee1$(_context1) {
        while (1) switch (_context1.prev = _context1.next) {
          case 0:
            if (options === void 0) {
              options = {};
            }
            _context1.next = 3;
            return this.__fetch({
              method: 'PATCH',
              body: body || this._body
            }, options);
          case 3:
            resp = _context1.sent;
            return _context1.abrupt("return", this.__postFetch('PATCH', resp, {
              options: options
            }));
          case 5:
          case "end":
            return _context1.stop();
        }
      }, _callee1, this);
    }));
    function PATCH(_x19, _x20) {
      return _PATCH.apply(this, arguments);
    }
    return PATCH;
  }();
  return _createClass(ApiRequest, [{
    key: "url",
    get: function get() {
      var isFullPath = /^(https?:)?\/{2}/gi.test(this._path);
      var urlPath = isFullPath ? this._path : "" + ApiRequest.getURL() + this._path;
      var url = new URL(urlPath);
      if (this._options.hasStringQuery && !!url.search) {
        url.search += "&" + this.query;
      } else {
        url.search = this.query;
      }
      return url;
    }
  }, {
    key: "query",
    get: function get() {
      var q = sanitize(this._query);
      var search = new URLSearchParams(q).toString();
      return search;
    }
  }]);
}();

function isValidDate(date) {
  return date instanceof Date && !isNaN(date.getTime());
}

dayjs.extend(dayjsAdvFmt);
function formatDate(date, format, fallback, options) {
  var _ref;
  if (format === void 0) {
    format = 'DD MMM YYYY';
  }
  if (fallback === void 0) {
    fallback = '---';
  }
  var resolvedLanguage = (_ref = i18next.resolvedLanguage || i18next.language) != null ? _ref : 'en';
  // @ts-expect-error - Attempt to parse date
  if (!isValidDate(dayjs(date).toDate()) && !isValidDate(date)) {
    return fallback;
  }
  var dateStr = isDate(date) ? date.toISOString() : date;
  var parsedDate = dayjs(dateStr);
  var isValid = parsedDate.isValid();
  var isNone = isEmpty(dateStr);
  if (!isValid || isNone) {
    return fallback;
  }
  var isCurrentYear = parsedDate.year() === dayjs().year();
  if (options != null && options.hideCurrentYear && isCurrentYear) {
    var fmt = format.replaceAll(/Y/gi, '');
    return parsedDate.locale(resolvedLanguage).format(fmt);
  }
  return parsedDate.locale(resolvedLanguage).format(format);
}
formatDate.fromAny = function (date, format, fallback) {
  var _ref2;
  if (format === void 0) {
    format = 'DD MMM YYYY';
  }
  if (fallback === void 0) {
    fallback = '---';
  }
  var resolvedLanguage = (_ref2 = i18next.resolvedLanguage || i18next.language) != null ? _ref2 : 'en';
  var dt = parseDateTime(date);
  if (dt === null) {
    return fallback;
  }
  return dayjs(DateTime.isDateTime(dt) ? dt.toISO() : dt).locale(resolvedLanguage).format(format);
};
function parseDateTime(date, fallback) {
  if (fallback === void 0) {
    fallback = null;
  }
  var dt;
  var invalid;
  var fromFn = [DateTime.fromISO, DateTime.fromRFC2822, DateTime.fromHTTP, DateTime.fromSQL, DateTime.fromMillis, DateTime.fromSeconds, DateTime.fromJSDate];
  for (var _i = 0, _fromFn = fromFn; _i < _fromFn.length; _i++) {
    var fn = _fromFn[_i];
    try {
      // @ts-expect-error - Attempt to parse date
      dt = fn(date);
      // @ts-expect-error - Attempt to parse date
      if (dt.invalid === null) {
        invalid = false;
        break;
      }
    } catch (_unused) {
      invalid = true;
    }
  }
  if (!dt || invalid) {
    return fallback;
  }
  return dt;
}
var DIVISIONS = [{
  amount: 60,
  unit: 'seconds'
}, {
  amount: 60,
  unit: 'minutes'
}, {
  amount: 24,
  unit: 'hours'
}, {
  amount: 7,
  unit: 'days'
}, {
  amount: 4.34524,
  unit: 'weeks'
}, {
  amount: 12,
  unit: 'months'
}, {
  amount: Number.POSITIVE_INFINITY,
  unit: 'years'
}];
function formatTimeAgo(date) {
  var _ref3;
  var resolvedLanguage = (_ref3 = i18next.resolvedLanguage || i18next.language) != null ? _ref3 : 'en';
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  var formatter = new Intl.RelativeTimeFormat(resolvedLanguage, {
    numeric: 'auto'
  });
  var oldDate = new Date(date);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  var duration = (oldDate - new Date()) / 1000;
  for (var i = 0; i <= DIVISIONS.length; i++) {
    var division = DIVISIONS[i];
    if (Math.abs(duration) < division.amount) {
      return formatter.format(Math.round(duration), division.unit);
    }
    duration /= division.amount;
  }
  return formatDate(date);
}
function addUnit(date, unit, value) {
  var _dayjs$add;
  if (unit === void 0) {
    unit = 'day';
  }
  return (_dayjs$add = dayjs(date).add(value, unit)) == null ? void 0 : _dayjs$add.toDate();
}

/**
 * Formats a Date or a Date String to a 12h time string in the format hh:mm A
 *
 * examples:
 * - ex: 11:20:30 -> 11:20 AM
 * - ex: 13:00:00 -> 01:00 PM
 *
 * @param date Date or a date string that is compatible with the JavaScript Date constructor
 * @returns a string in the format hh:mm A
 */
function formatTime(date) {
  return dayjs(date).format('hh:mm A');
}
formatTime.fromCreatedAt = function (date) {
  var _date$normal$split = date.normal.split(' '),
    timeString = _date$normal$split[1];
  var ms = Date.parse(timeString);
  var dateFrom = new Date(ms);
  formatTime(dateFrom);
};

/**
 *
 * @param datetime - ISO formatted date sting
 * @param fallback - returned if failed
 */
function relativeDate(datetime, fallback) {
  if (fallback === void 0) {
    fallback = '---';
  }
  if (!datetime) {
    return fallback;
  }
  var dt = DateTime.fromISO(datetime);
  if (dt.isValid) {
    return dt.toRelative();
  }
  return fallback;
}

var isValidTimeString = function isValidTimeString(time) {
  var isValidFormat = !!time && /^\d{2}:\d{2}(:\d{2})?$/.test(time);
  if (!isValidFormat) {
    return false;
  }
  var timeParts = time.split(':');
  var hours = parseInt(timeParts[0], 10);
  var minutes = parseInt(timeParts[1], 10);
  var seconds = timeParts.length === 3 ? parseInt(timeParts[2], 10) : 0;
  var isValidValues = hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59 && seconds >= 0 && seconds <= 59;
  return isValidFormat && isValidValues;
};
var parseTimeString = function parseTimeString(time) {
  if (!isValidTimeString(time)) {
    throw new Error('Invalid time format. Expected HH:mm:ss or HH:mm');
  }
  var timeParts = time.split(':');
  var hours = parseInt(timeParts[0], 10);
  var minutes = parseInt(timeParts[1], 10);
  var seconds = timeParts.length === 3 ? parseInt(timeParts[2], 10) : 0;
  return {
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
};

dayjs.extend(utc);
dayjs.extend(timezone);
var API_TIME_FORMAT = 'HH:mm:ss';
var API_DATE_FORMAT = 'YYYY-MM-DD';
var API_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
var isDateValid = function isDateValid(date) {
  return !!date && isValidDate(dayjs(date).toDate());
};
/**
 * Convert date to UTC
 * @param date - date to convert
 * @returns UTC date
 */
function convertDateToUTC(date, format) {
  if (format === void 0) {
    format = API_DATE_FORMAT;
  }
  if (!isDateValid(date)) {
    throw new Error('Invalid date');
  }
  return dayjs(date).utc().format(format);
}
/**
 * Converts time to utc
 * @param time - time to convert in format HH:mm:ss or HH:mm by default it is treated as the default timezone of dayjs.tz()
 * @param format - format of the output time
 * @returns utc time, by default in format HH:mm:ss
 */
function convertTimeToUTC(time, format) {
  if (format === void 0) {
    format = API_TIME_FORMAT;
  }
  var today = dayjs.tz();
  var _parseTimeString = parseTimeString(time),
    hours = _parseTimeString.hours,
    minutes = _parseTimeString.minutes,
    seconds = _parseTimeString.seconds;
  var localDateTime = today.set('hour', hours).set('minute', minutes).set('second', seconds);
  return localDateTime.utc().format(format);
}
/**
 * Converts utc time to local time
 * @param time - time to convert
 * @returns local time
 */
function convertUtcTimeToLocalTime(time, format) {
  if (format === void 0) {
    format = 'HH:mm:ss';
  }
  var _parseTimeString2 = parseTimeString(time),
    hours = _parseTimeString2.hours,
    minutes = _parseTimeString2.minutes,
    seconds = _parseTimeString2.seconds;
  var utcTime = dayjs.utc().set('hour', hours).set('minute', minutes).set('second', seconds);
  var localTime = utcTime.local();
  return localTime.format(format);
}
/**
 * Convert start of a date range to UTC
 * @param date - date to convert
 * @returns UTC date
 */
function convertStartDateToUTC(date) {
  if (!isDateValid(date)) {
    throw new Error('Invalid date');
  }
  return convertDateToUTC(dayjs(date).startOf('day').toDate(), API_DATE_TIME_FORMAT);
}
/**
 * Convert end of a date range to UTC
 * @param date - date to convert
 * @returns UTC date
 */
function convertEndDateToUTC(date) {
  if (!isDateValid(date)) {
    throw new Error('Invalid date');
  }
  return convertDateToUTC(dayjs(date).endOf('day').toDate(), API_DATE_TIME_FORMAT);
}

var symbolToCode = {
  '>': 'greater than',
  '>=': 'greater or equal',
  '<': 'lower than',
  '<=': 'lower or equal',
  '=': 'is',
  '!=': 'not',
  like: 'fz',
  between: 'between'
};
var codeToSymbol = {
  'greater than': '>',
  'greater or equal': '>=',
  'lower than': '<',
  'lower or equal': '<=',
  is: '=',
  not: '!=',
  fz: 'like',
  between: 'between'
};
var RelationalOperatorsMap = /*#__PURE__*/function () {
  function RelationalOperatorsMap() {}
  RelationalOperatorsMap.allSymbols = function allSymbols() {
    return Object.keys(symbolToCode);
  };
  RelationalOperatorsMap.allCodes = function allCodes() {
    return Object.keys(codeToSymbol);
  };
  RelationalOperatorsMap.getSymbol = function getSymbol(c, filter) {
    if (Array.isArray(c)) {
      var symbolsList = Object.keys(codeToSymbol);
      if (filter != null && filter.exclude) {
        return symbolsList.filter(function (i) {
          return !c.includes(i);
        }).map(function (x) {
          return codeToSymbol[x];
        });
      } else if (filter != null && filter.only) {
        return symbolsList.filter(function (i) {
          return c.includes(i);
        }).map(function (x) {
          return codeToSymbol[x];
        });
      }
      throw new Error('Got an OpCode[] but { exclude, only } not set');
    }
    return get(codeToSymbol, c, c);
  };
  RelationalOperatorsMap.getCode = function getCode(s, filter) {
    if (Array.isArray(s)) {
      var symbolsList = Object.keys(symbolToCode);
      if (filter != null && filter.exclude) {
        return symbolsList.filter(function (i) {
          return !s.includes(i);
        }).map(function (x) {
          return symbolToCode[x];
        });
      } else if (filter != null && filter.only) {
        return symbolsList.filter(function (i) {
          return s.includes(i);
        }).map(function (x) {
          return symbolToCode[x];
        });
      }
      throw new Error('Got an OpSymbol[] but { exclude, only } not set');
    }
    return get(symbolToCode, s, s);
  }
  /** get only values from array|objects
   * @deprecated
   * @example
   * use `getCode(['='], { only: true })
   */;
  RelationalOperatorsMap.getOnlySymbol = function getOnlySymbol(only) {
    var symbolsList = Object.keys(symbolToCode);
    return symbolsList.filter(function (symbol) {
      return only.includes(symbol);
    });
  }
  /** remove null|undefined values from array|objects
   * @deprecated - foobar
   * @example
   * use `getCode(['='], { exclude: true })
   */;
  RelationalOperatorsMap.getExcludeSymbol = function getExcludeSymbol(exclude) {
    var symbolsList = Object.keys(symbolToCode);
    return symbolsList.filter(function (item) {
      return !exclude.includes(item);
    });
  };
  return RelationalOperatorsMap;
}();

function handleDownloadLocalLink(_ref) {
  var linkSrc = _ref.linkSrc,
    downloadLink = _ref.downloadLink;
  var link = document.createElement('a');
  link.href = linkSrc;
  link.download = downloadLink;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function getSnakeCase(str) {
  return str == null ? void 0 : str.toLowerCase().replace(/ /g, '_');
}

var LoginState = /*#__PURE__*/function () {
  function LoginState() {}
  LoginState.load = function load() {
    LoginState.loadSS();
    LoginState.loadLS();
  };
  LoginState.loadLS = function loadLS() {
    LoginState.state.current = {};
    Object.keys(localStorage).forEach(function (localStorageKey) {
      return LoginState.setCurrent(localStorageKey, LoginState.getLS(localStorageKey));
    });
  };
  LoginState.loadSS = function loadSS() {
    LoginState.state.current = {};
    Object.keys(sessionStorage).forEach(function (sessionStorageKey) {
      return LoginState.setCurrent(sessionStorageKey, LoginState.getSS(sessionStorageKey));
    });
  };
  LoginState.setItem = function setItem(key, value) {
    LoginState.setCurrent(key, value);
    if ((value == null ? void 0 : value.keepSignIn) !== false) {
      LoginState.setLS(key, value);
    } else {
      LoginState.setSS(key, value);
    }
  };
  LoginState.getItem = function getItem(key, otherwise) {
    var lsVal = LoginState.getLS(key);
    var ssVal = LoginState.getSS(key);
    var val = LoginState.getCurrent(key);
    if (lsVal && val === undefined) {
      LoginState.setItem(key, lsVal);
    } else if (ssVal && val === undefined) {
      LoginState.setItem(key, ssVal);
    }
    return val || lsVal || ssVal || otherwise;
  };
  LoginState.setCurrent = function setCurrent(key, value) {
    LoginState.state.current[key] = value;
  };
  LoginState.getCurrent = function getCurrent(key) {
    return get(LoginState.state.current, key);
  };
  LoginState.setLS = function setLS(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  };
  LoginState.getLS = function getLS(key) {
    var _localStorage$getItem;
    return parseJson((_localStorage$getItem = localStorage.getItem(key)) != null ? _localStorage$getItem : '{}');
  };
  LoginState.setSS = function setSS(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  };
  LoginState.getSS = function getSS(key) {
    var _sessionStorage$getIt;
    return parseJson((_sessionStorage$getIt = sessionStorage.getItem(key)) != null ? _sessionStorage$getIt : '{}');
  };
  return LoginState;
}();
LoginState.state = /*#__PURE__*/createRef();

var queryStateCtx = /*#__PURE__*/createContext({
  searchObject: {},
  updateQuery: function updateQuery() {},
  searchString: '',
  deleteQuery: function deleteQuery() {}
});
queryStateCtx.displayName = 'QueryStateCtx';
var QueryStateProvider = function QueryStateProvider(props) {
  var _useQueryStringProvid = useQueryStringProvider(props.initialQuery),
    searchObject = _useQueryStringProvid.searchObject,
    updateQuery = _useQueryStringProvid.updateQuery,
    searchString = _useQueryStringProvid.searchString,
    deleteQuery = _useQueryStringProvid.deleteQuery;
  var ctx = {
    searchObject: searchObject,
    updateQuery: updateQuery,
    searchString: searchString,
    deleteQuery: deleteQuery
  };
  return React.createElement(queryStateCtx.Provider, {
    value: ctx
  }, props.children);
};
var useQueryString = function useQueryString() {
  var _useContext = useContext(queryStateCtx),
    searchObject = _useContext.searchObject,
    updateQuery = _useContext.updateQuery,
    searchString = _useContext.searchString,
    deleteQuery = _useContext.deleteQuery;
  return [searchObject, updateQuery, searchString, deleteQuery];
};
var useQueryStringProvider = function useQueryStringProvider(init) {
  var location = useLocation();
  var navigate = useNavigate();
  var _qs = qs(),
    parseQs = _qs.parse,
    stringifyQs = _qs.stringify;
  var _useState = useState(parseQs(location.search)),
    searchObject = _useState[0],
    setSearchObject = _useState[1];
  useLayoutEffect(function () {
    setSearchObject(parseQs(location.search));
  }, [location.search]);
  /**
   * updateQuery
   * @param {object} value - query string object
   * @param {object} [options] - update options
   * @param {function} [options.cb] - callback func
   * @param {Boolean} [options.replace] - replace history
   * @param {Boolean} [options.noMerge=false] - don't merge query string
   */
  var updateQuery = function updateQuery(value, options) {
    var _ref = options || {},
      cb = _ref.cb,
      replace = _ref.replace,
      noMerge = _ref.noMerge;
    setSearchObject(function (s) {
      var search = noMerge ? stringifyQs(Object.assign({}, value)) : stringifyQs(Object.assign({}, s, value));
      if (replace) {
        navigate({
          search: search
        }, {
          replace: true
        });
      } else {
        navigate({
          search: search
        });
      }
      if (isFunction(cb)) {
        cb(search);
      }
      return parseQs(search);
    });
  };
  var deleteQuery = function deleteQuery(queryKey) {
    if (queryKey) {
      setSearchObject(function (s) {
        var restQueries = _objectWithoutPropertiesLoose(s, [queryKey].map(_toPropertyKey));
        return restQueries;
      });
    } else {
      setSearchObject({});
    }
  };
  var isFirstMount = useFirstMountState();
  useEffect(function () {
    if (isFirstMount) {
      updateQuery(init || {});
    }
  });
  useDebugValue({
    searchString: location.search,
    setSearchObject: setSearchObject,
    searchObject: searchObject,
    updateQuery: updateQuery,
    location: location,
    history: navigate
  });
  return {
    searchObject: searchObject,
    updateQuery: updateQuery,
    searchString: location.search,
    deleteQuery: deleteQuery
  };
};
function qs(opt) {
  if (opt === void 0) {
    opt = {};
  }
  var options = _extends({
    arrayFormat: 'separator',
    arrayFormatSeparator: ':'
  }, opt);
  return {
    stringify: function stringify$1(o) {
      if (isObject$1(o)) {
        return stringify(o, options);
      }
      throw new Error("qs cant stringify " + typeof o);
    },
    parse: function parse$1(o) {
      return Object.assign({}, parse(o, options));
    }
  };
}

var phoneNumberRegex = /^\d+$/;
var oneWordNameRegex = /^[-a-zA-Z\u0621-\u064A]+$/;
var nameRegex = /^[a-zA-Z\u0621-\u064A\s]+$/;
var passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^(){}[\]\-+.,~|_])[A-Za-z\d@$!%*?&#^(){}[\]\-+.,~|_]{8,}$/;
var emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
var sharedRegex = {
  emailRegex: emailRegex,
  phoneNumberRegex: phoneNumberRegex,
  oneWordNameRegex: oneWordNameRegex,
  nameRegex: nameRegex,
  passwordRegex: passwordRegex
};

var nameRegex$1 = sharedRegex.nameRegex,
  oneWordNameRegex$1 = sharedRegex.oneWordNameRegex,
  passwordRegex$1 = sharedRegex.passwordRegex,
  phoneNumberRegex$1 = sharedRegex.phoneNumberRegex;
var emailSchema = function emailSchema(_ref) {
  var _ref$name = _ref.name,
    name = _ref$name === void 0 ? t('common:email') : _ref$name,
    translate = _ref.t;
  return string().required(t('common:required_validation', {
    name: name
  })).email((translate || t)('common:email_validation', {
    name: name
  }));
};
var passwordSchema = function passwordSchema(_ref2) {
  var _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? t('common:password') : _ref2$name,
    _ref2$min = _ref2.min,
    min = _ref2$min === void 0 ? 12 : _ref2$min;
  return string().required(t('common:required_validation', {
    name: name
  })).min(min, t('common:min_length_validation', {
    name: name,
    min: min
  })).matches(passwordRegex$1, {
    message: t('common:password_includes_validation', {
      name: name
    })
  });
};
var passwordConfirmationSchema = function passwordConfirmationSchema(_ref3) {
  var _ref3$name = _ref3.name,
    name = _ref3$name === void 0 ? t('common:confirm_password') : _ref3$name,
    translate = _ref3.t;
  return string().required((translate || t)('common:required_validation', {
    name: name
  })).oneOf([ref('password'), null], (translate || t)('common:password_confirmation_validation', {
    name: name
  }));
};
var phoneNumberSchema = function phoneNumberSchema(_ref4) {
  var _ref4$name = _ref4.name,
    name = _ref4$name === void 0 ? t('common:phone_number') : _ref4$name,
    translate = _ref4.t;
  return string().required((translate || t)('common:required_validation', {
    name: name
  })).matches(phoneNumberRegex$1, (translate || t)('common:phone_number_validation', {
    name: name
  }));
};
var nameSchema = function nameSchema(_ref5) {
  var _ref5$name = _ref5.name,
    name = _ref5$name === void 0 ? t('common:name') : _ref5$name;
  return string().required(t('common:required_validation', {
    name: name
  })).matches(nameRegex$1, {
    message: t('common:invalid_field_letter', {
      name: name
    })
  });
};
var oneWordNameSchema = function oneWordNameSchema(_ref6) {
  var _ref6$name = _ref6.name,
    name = _ref6$name === void 0 ? t('common:name') : _ref6$name;
  return string().trim().required(t('common:required_validation', {
    name: name
  })).test('two-word-name', t('common:two_word_name', {
    name: name
  }), function (value) {
    if (value && value.length > 1) {
      return value.split(' ').length <= 1 && !value.endsWith('-');
    }
    return true;
  }).matches(oneWordNameRegex$1, {
    message: t('common:invalid_field_letter', {
      name: name
    })
  });
};
var numberSchema = function numberSchema(_ref7) {
  var _ref7$name = _ref7.name,
    name = _ref7$name === void 0 ? t('common:field') : _ref7$name;
  return number().transform(function (value) {
    return isNaN(value) ? undefined : value;
  }).required(t('common:required_validation', {
    name: name
  })).typeError(t('common:validation_number', {
    name: name
  })).typeError(t('common:validation_number', {
    name: name
  }));
};
var positiveNumberSchema = function positiveNumberSchema(_ref8) {
  var _ref8$name = _ref8.name,
    name = _ref8$name === void 0 ? t('common:field') : _ref8$name;
  return number().transform(function (value) {
    return isNaN(value) ? undefined : value;
  }).required(t('common:required_validation', {
    name: name
  })).typeError(t('common:validation_number', {
    name: name
  })).positive(t('common:validation_positive_number', {
    name: name
  }));
};
var negativeNumberSchema = function negativeNumberSchema(_ref9) {
  var _ref9$name = _ref9.name,
    name = _ref9$name === void 0 ? t('common:field') : _ref9$name;
  return number().transform(function (value) {
    return isNaN(value) ? undefined : value;
  }).required(t('common:required_validation', {
    name: name
  })).typeError(t('common:validation_number', {
    name: name
  })).negative(t('common:validation_negative_number', {
    name: name
  }));
};
var integerSchema = function integerSchema(_ref0) {
  var _ref0$name = _ref0.name,
    name = _ref0$name === void 0 ? t('common:field') : _ref0$name;
  return number().transform(function (value) {
    return isNaN(value) ? undefined : value;
  }).required(t('common:required_validation', {
    name: name
  })).typeError(t('common:validation_integer', {
    name: name
  })).integer(t('common:validation_integer', {
    name: name
  }));
};
var positiveIntegerSchema = function positiveIntegerSchema(_ref1) {
  var _ref1$name = _ref1.name,
    name = _ref1$name === void 0 ? t('common:field') : _ref1$name;
  return number().transform(function (value) {
    return isNaN(value) ? undefined : value;
  }).typeError(t('common:validation_integer', {
    name: name
  })).required(t('common:required_validation', {
    name: name
  })).integer(t('common:validation_integer', {
    name: name
  })).positive(t('common:validation_positive_number', {
    name: name
  }));
};
var dateSchema = function dateSchema(_ref10) {
  var _ref10$name = _ref10.name,
    name = _ref10$name === void 0 ? t('common:date') : _ref10$name,
    _ref10$min = _ref10.min,
    min = _ref10$min === void 0 ? null : _ref10$min,
    _ref10$max = _ref10.max,
    max = _ref10$max === void 0 ? null : _ref10$max;
  return date().required(t('common:required_validation', {
    name: name
  })).min(min, t('common:date_min', {
    name: name,
    min: min
  })).max(max, t('common:date_max', {
    name: name,
    max: max
  }));
};
var urlSchema = function urlSchema(_ref11) {
  var _ref11$name = _ref11.name,
    name = _ref11$name === void 0 ? t('common:field') : _ref11$name;
  return string().required(t('common:required_validation', {
    name: name
  })).url(t('common:validation_url', {
    name: name
  }));
};
var sharedSchema = {
  emailSchema: emailSchema,
  passwordSchema: passwordSchema,
  passwordConfirmationSchema: passwordConfirmationSchema,
  phoneNumberSchema: phoneNumberSchema,
  nameSchema: nameSchema,
  oneWordNameSchema: oneWordNameSchema,
  numberSchema: numberSchema,
  positiveNumberSchema: positiveNumberSchema,
  negativeNumberSchema: negativeNumberSchema,
  integerSchema: integerSchema,
  positiveIntegerSchema: positiveIntegerSchema,
  dateSchema: dateSchema,
  urlSchema: urlSchema
};

var usePagination = function usePagination(_ref) {
  var pageNum = _ref.pageNum,
    pagesCount = _ref.pagesCount;
  var _useQueryString = useQueryString(),
    searchObject = _useQueryString[0],
    updateQuery = _useQueryString[1];
  var page = searchObject.page;
  if (parseInt(page) !== pageNum) {
    console.warn("Pagination mismatch query vs api, expected " + page + " found " + pageNum);
  }
  var onPageChange = useCallback(function (num) {
    updateQuery({
      page: num.toString() || '1'
    });
  }, [updateQuery]);
  var pagesList = Array.from(new Set([1, 2, pageNum - 1, pageNum, pageNum + 1, pagesCount - 1, pagesCount].filter(function (num) {
    return num > 0;
  }))).reduce(function (array, num, index, numArr) {
    var prv = numArr[index - 1];
    var isCurrent = pageNum == num;
    if (num - prv > 1) {
      array.push({
        dff: num - prv,
        isMany: true
      });
    }
    if (isNaN(num) || num > pagesCount || index === num) {
      return array;
    }
    array.push({
      num: num,
      isCurrent: isCurrent
    });
    return array;
  }, []);
  return {
    pagesList: pagesList,
    pagesCount: pagesCount,
    page: page,
    onPageChange: onPageChange
  };
};

function useScreenSize() {
  var _useState = useState({
      width: window.innerWidth,
      height: window.innerHeight
    }),
    screenSize = _useState[0],
    setScreenSize = _useState[1];
  useEffect(function () {
    var handleResize = function handleResize() {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
    window.addEventListener('resize', handleResize);
    // Clean up the event listener when the component unmounts
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return {
    screenSize: screenSize
  };
}

var useDrawerManagement = function useDrawerManagement(_ref) {
  var onDrawerDismiss = _ref.onDrawerDismiss;
  var _useState = useState(false),
    isAddEditDrawerOpen = _useState[0],
    setIsAddEditDrawerOpen = _useState[1];
  var _useState2 = useState(),
    editId = _useState2[0],
    setEditId = _useState2[1];
  var openDrawer = useCallback(function (id) {
    setEditId(id);
    setIsAddEditDrawerOpen(true);
  }, []);
  var handleDrawerDismiss = useCallback(function () {
    setIsAddEditDrawerOpen(false);
    setEditId(undefined);
    onDrawerDismiss == null || onDrawerDismiss();
  }, [onDrawerDismiss]);
  return {
    isAddEditDrawerOpen: isAddEditDrawerOpen,
    editId: editId,
    openDrawer: openDrawer,
    handleDrawerDismiss: handleDrawerDismiss
  };
};

function useBoolean() {
  var _useState = useState(false),
    value = _useState[0],
    setValue = _useState[1];
  var setTrue = useCallback(function () {
    setValue(true);
  }, []);
  var setFalse = useCallback(function () {
    setValue(false);
  }, []);
  var toggle = useCallback(function () {
    setValue(function (v) {
      return !v;
    });
  }, []);
  return {
    value: value,
    setValue: setValue,
    toggle: toggle,
    setTrue: setTrue,
    setFalse: setFalse
  };
}

function useHover() {
  var ref = useRef(null);
  var _useState = useState(false),
    isHovering = _useState[0],
    setHovering = _useState[1];
  var setYes = useCallback(function () {
    return setHovering(true);
  }, []);
  var setNo = useCallback(function () {
    return setHovering(false);
  }, []);
  useEffect(function () {
    setHovering(false);
    var element = ref.current;
    if (!element) {
      return;
    }
    element.addEventListener('mouseenter', setYes);
    element.addEventListener('mouseleave', setNo);
    return function () {
      element.removeEventListener('mouseenter', setYes);
      element.removeEventListener('mouseleave', setNo);
    };
  }, []);
  return [ref, isHovering];
}

var defaultFallback = '---';
var formatDate$1 = function formatDate(date, fallback, options) {
  if (!date) {
    return fallback != null ? fallback : defaultFallback;
  }
  var dateObj = dayjs(date).toDate();
  try {
    var _options$locale$toStr, _options$locale;
    return new Intl.DateTimeFormat((_options$locale$toStr = options == null || (_options$locale = options.locale) == null ? void 0 : _options$locale.toString()) != null ? _options$locale$toStr : undefined, _extends({}, options)).format(dateObj);
  } catch (_unused) {
    return fallback != null ? fallback : defaultFallback;
  }
};
var formatLocaleDate = function formatLocaleDate(date, fallback, options) {
  return formatDate$1(date, fallback, _extends({
    dateStyle: 'medium'
  }, options));
};
var formatLocaleTime = function formatLocaleTime(date, fallback, options) {
  return formatDate$1(date, fallback, _extends({
    timeStyle: 'short'
  }, options));
};
var formatLocaleDateTime = function formatLocaleDateTime(date, fallback, options) {
  return formatDate$1(date, fallback, _extends({
    dateStyle: 'medium',
    timeStyle: 'short'
  }, options));
};
function useDate() {
  return {
    formatLocaleDate: formatLocaleDate,
    formatLocaleTime: formatLocaleTime,
    formatLocaleDateTime: formatLocaleDateTime
  };
}

function useDevice() {
  var _useState = useState(false),
    isMobile = _useState[0],
    setIsMobile = _useState[1];
  useEffect(function () {
    var parser = new UAParser();
    var deviceType = parser.getDevice().type;
    // Check if the device is a mobile device
    setIsMobile(deviceType === 'mobile');
  }, []);
  return {
    isMobile: isMobile
  };
}

function useMediaQuery(query) {
  var _useState = useState(false),
    value = _useState[0],
    setValue = _useState[1];
  useEffect(function () {
    function onChange(event) {
      setValue(event.matches);
    }
    var result = matchMedia(query);
    result.addEventListener("change", onChange);
    setValue(result.matches);
    return function () {
      return result.removeEventListener("change", onChange);
    };
  }, [query]);
  return value;
}

var formatCurrency = function formatCurrency(value, _ref) {
  var fractionDigits = _ref.fractionDigits,
    currencyCode = _ref.currencyCode,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? 'en' : _ref$locale;
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode,
      maximumFractionDigits: fractionDigits != null ? fractionDigits : 2
    }).format(value || 0);
  } catch (_unused) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'EGP',
      maximumFractionDigits: fractionDigits != null ? fractionDigits : 2
    }).format(value || 0);
  }
};

function convertSecondsToTime(seconds) {
  if (seconds >= 60) {
    var minutes = parseInt((seconds / 60).toString().padStart(2, '0'));
    var remainingSeconds = (seconds % 60).toString().padStart(2, '0');
    return minutes + ":" + remainingSeconds;
  }
  return '00:' + seconds.toString().padStart(2, '0');
}

export { API_DATE_FORMAT, API_DATE_TIME_FORMAT, API_TIME_FORMAT, ApiRequest, ECampaignApprovalStatus, ECampaignStatus, EDateFilterCompareTo, EMerchantPlan, EMetricChange, LoginState, QueryStateProvider, RelationalOperatorsMap, abbreviateNumber, addUnit, convertDateToUTC, convertEndDateToUTC, convertSecondsToTime, convertStartDateToUTC, convertTimeToUTC, convertUtcTimeToLocalTime, countryCodes, formatCurrency, formatDate, formatLocaleDate, formatLocaleDateTime, formatLocaleTime, formatNumberCommas, formatNumberPhone, formatNumberThousands, formatTime, formatTimeAgo, getSnakeCase, handleDownloadLocalLink, isDecimalNumber, isValidDate, numberSuffix, numberWithSpaces, parseDateTime, parseJson, relativeDate, removeLeadingDecimalZeros, sanitize, sharedRegex, sharedSchema, toFormData, useBoolean, useDate, useDevice, useDocumentDirection, useDrawerManagement, useFormatNumber, useHover, useMediaQuery, usePagination, useQueryString, useScreenSize, useI18nTranslation as useTranslation };
//# sourceMappingURL=zeal-lib.esm.js.map
